import { EffectHandler } from "../types/editor"

const AliasChangeHandler: EffectHandler = {
    // 添加
    addEffect(editor, selection, value) {
        editor.addcontainEffectHtml({
            range: selection.range,
            effectType: 'aliasChange',
            effectUIType: 'aliasChangeInner',
            idName: 'aliasGroupKey',
            param: {
                aliasContent: value.aliasContent,
                aliasContent2: value.aliasContent2,
                originAlias: selection.rangeText,
            }
        })
    },
    // 修改
    modifyEffect(editor, selection, value) { },
    // 删除
    removeEffect(editor, selection) { },
}
export default AliasChangeHandler